
import React from 'react';

import ListInfo from './ListInfo';

const ListInfoNoData = () => {
    return (
        <ListInfo info="Není zde nic co by se dalo zobrazit" />
    );
}

export default ListInfoNoData;
